import React from 'react';
import Banner from '../banner';
import Promotions from '../promotions';
import Footer from '../footer';
import AppDrawer from '../drawer';
import Cart from '../cart';
import Checkout from '../checkout';
import SearchBox from '../search';
import { InfoCompany } from '../InfoCompany';
import { InfoCompanyDivision } from '../InfoCompanyDivision';

const Home = () => {
  return (
    <>
      <Banner />
      <Promotions />
      <InfoCompany />
      <InfoCompanyDivision/>
      <Footer />
      <AppDrawer />
      <Cart />
      <Checkout />
      <SearchBox />
    </>
  );
};

export default Home;
